import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  GridAdmin
} from 'src/components/containers/configurator/ScreenLayout'
// import Support from 'src/components/layout/Support'
import ClientDetails from '../../components/organisms/admin/ClientDetails'
import ProductConfigurator from '../../components/organisms/configurator/ProductConfigurator'
import { VerticalAlignWrapper } from '../../components/containers/configurator/ConfiguratorBox'
// import BottomNavigation from '../../components/organisms/configurator/BottomNavigation'
import { StoreProps } from '../../stores'
import ProductList from 'src/components/organisms/admin/ProductList'

interface Props extends StoreProps {
  location: any
  history: any
  match: any
}

@inject('adminStore')
@observer
class AdminScreen extends React.Component<Props> {
  components = new Map<string, JSX.Element>()

  constructor(props) {
    super(props)
    this.components.set('PRODUCT', <ProductConfigurator />)
    this.state = { scrollingAdjusted: false }
  }

  componentDidMount() {
    const { adminStore, match } = this.props
    if (!adminStore.isAllLoaded) adminStore.initWithOrderId(match.params.orderid)
  }

  loading = () => {
    return (
      <div style={{ height: 450 }}>
        <VerticalAlignWrapper style={{ justifyContent: 'center' }}>
          <h1>Lädt...</h1>
        </VerticalAlignWrapper>
      </div>
    )
  }

  order = () => {
    const positionToScroll = window.sessionStorage.getItem('scrollPosition')
    if (positionToScroll) {
      window.sessionStorage.removeItem('scrollPosition')
      setTimeout(() => window.scrollTo(0, +positionToScroll * -1), 0)
    }
    return (
      <>
        <GridAdmin>
          <ClientDetails />
          <ProductList />
        </GridAdmin>
      </>
    )
  }
//*[@id="root"]/div/main/div/div[1]/div[4]
  render() {
    const { adminStore, location } = this.props

    const metaTitle = 'Ihre Planung | Benu | Ihr moderner Bestatter'
    const metaDesc =
      'Benu - Ihr moderner Bestatter ✓ Alle Bestattungsarten ✓ In ganz Österreich ✓ Persönliche Beratung ✓ Faire & Transparente Preise'
    const metaUrl = `https://www.benu.at${location.pathname}`
    const metaImg = 'http://dev.benu.at/benu_logo.png'
    return (
      <div style={{ backgroundColor: '#D5E4E6' }}>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{metaTitle}</title>
          <link rel='canonical' href={metaUrl} />

          <meta name='description' content={metaDesc} />
          <meta property='og:title' content={metaTitle} />
          <meta property='og:description' content={metaDesc} />
          <meta property='og:url' content={metaUrl} />
          <meta property='og:type' content='article' />
          <meta property='og:image' content={metaImg} />

          <meta name='author' content='Benu GmbH' />

          <meta name='twitter:card' content={metaImg} />
          <meta name='twitter:site' content='@benu.at' />
          <meta name='twitter:creator' content='@benu.at' />
          <meta name='twitter:title' content={metaTitle} />
          <meta name='twitter:description' content={metaDesc} />
          <meta name='twitter:image' content={metaImg} />

          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        {adminStore.isAllLoaded ? this.order() : this.loading()}

      </div>
    )
  }
}

export default withRouter(AdminScreen)



// WEBPACK FOOTER //
// ./src/screens/admin/AdminScreen.tsx